var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [_c('memo-form', _vm._g({
    model: {
      value: _vm.memo,
      callback: function ($$v) {
        _vm.memo = $$v;
      },
      expression: "memo"
    }
  }, {
    post: _vm.post
  }))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }